import {connect} from 'react-redux';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import CollectionsPage from './collections';
import {resetTitle} from '../../../redux/actions/page';

function mapStateToProps() {
	return {};
}

function mapDispatchToProps(dispatch) {
	return {
		resetTitle: () => {
			dispatch(resetTitle());
		}
	};
}

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	lifecycle({
		componentWillMount() {
			this.props.resetTitle();
		}
	}),
	withHandlers({
		handleGoBack: props => () => {
			props.history.goBack();
		},
		handleShowFiles: props => id => {
			props.history.push(`/collections/${id}/files`);
		}
	})
);

export default enhance(CollectionsPage);



// WEBPACK FOOTER //
// ./src/client/pages/main/collections/index.js